import React from "react";
import "./App.css";
import LoadingPage from "./components/LoadingPage";

function App() {
  return (
    <div className="App">
      <LoadingPage />
    </div>
  );
}

export default App;
